import Enum from "./Enum";

export default Enum.create( {
	COMPLETE: "COMPLETE",
	INCOMPLETE: "INCOMPLETE",
} );
